import { render, staticRenderFns } from "./AuxiliaryApproversRoles.vue?vue&type=template&id=094664b6&"
import script from "./AuxiliaryApproversRoles.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryApproversRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports